import React,{Component} from 'react';
import i18next from "../../i18n.js";
import { v4 } from 'uuid';
export class CommentForm extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.comment ? Object.assign({
                commentBeanList: [],
                edit: this.props.comment ? true : false
        }, ...Object.keys(this.props.comment).map((key) => ({ [key]: this.props.comment[key] }))
        ) : { submitted: false };
    }
    render() {
        const { content, edit } = this.state;
        const { isAnswer } = this.props;
        const submitBtnText = this.props.submitBtnText ? this.props.submitBtnText : (edit ? i18next.t("comments.save") : (isAnswer ? i18next.t("comments.answer") : i18next.t("comments.add")));
        const cancelBtnText = this.props.cancelBtnText ? this.props.cancelBtnText : i18next.t("comments.cancel");
        const placeholder = isAnswer ? i18next.t("comments.answerPlaceholder") : i18next.t("comments.newPlaceholder");

        return (
            <div className={"comment-form" + (isAnswer ? " answer" : "")}>
                <form name="form">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="form-group">
                                <textarea placeholder={placeholder} onChange={(e) => this.setState({ content: e.target.value })} value={content} rows={isAnswer ? "1" : "3"} className="form-control"></textarea>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="btns">
                    {(edit) && <button className="btn comment-form-btn cancel" onClick={this.onCancel.bind(this)} >{cancelBtnText}</button>}
                    <button className="btn comment-form-btn" onClick={this.handleChangeComment.bind(this)} disabled={!content} >{submitBtnText}</button>
                </div>
            </div>
        );
    }
    handleChangeComment(e) {
        e.preventDefault();
        const user = JSON.parse(localStorage.getItem('user'));
        const dateTime = new Date().toUTCString();
        const { id, content, commentBeanList } = this.state;
        if (content) {
            this.props.handleChangeComment({
                id: id ? id : v4(),
                content: content,
                created: dateTime,
                position: user.position,
                commentBeanList: commentBeanList
            });
            this.setState({ content: '' });
        }
        else {
            this.setState({ submitted: true });
        }
    }
    onCancel() {
        if (this.props.onCancel) this.props.onCancel();
    }
}